import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M663-442H185q-16 0-28-12-11-11-11-28t11-28q12-12 28-12h478L531-654q-12-12-12-28 1-16 13-28 11-11 27-11t28 12l199 199q6 6 10 13 3 7 3 15t-3 15q-4 7-10 13L588-256q-12 12-28 12t-27-12q-12-11-12-28 0-16 12-28l130-130Z"/>',
  f: '<path d="M663-442H185q-16 0-28-12-11-11-11-28t11-28q12-12 28-12h478L531-654q-12-12-12-28 1-16 13-28 11-11 27-11t28 12l199 199q6 6 10 13 3 7 3 15t-3 15q-4 7-10 13L588-256q-12 12-28 12t-27-12q-12-11-12-28 0-16 12-28l130-130Z"/>',
};

export default data;
